import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { InputValidationMessage } from '@awaze/design-system.components.input';
import { Tick } from './tick';
import { CheckboxStyled, TickWrapStyled, InputCheckboxStyled, LabelStyled, HintStyled, } from './checkbox.styles';
/**
 * A basic checkbox component, that returns a onChange callback whenever its clicked/spaced etc.
 *
 * Currently the checkbox is not set up to be used within a form that is controlled by the `useForm()` hook.
 */
export const Checkbox = ({ id, label, checked, disabled = false, error = false, name, value, hint, errorChildren, errorStatus, onChange, variant, ...rest }) => {
    const labelIsString = typeof label === 'string';
    const [isError, setIsError] = useState(error);
    const changeErrorState = () => {
        if (isError) {
            setIsError(false);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs(CheckboxStyled, { htmlFor: id, disabled: disabled, alignTop: labelIsString, error: isError, variant: variant, children: [_jsxs(TickWrapStyled, { error: isError, checked: checked, children: [_jsx(InputCheckboxStyled, { checked: checked, disabled: disabled, onChange: (e) => {
                                    onChange(e);
                                    changeErrorState();
                                }, id: id, name: name, value: value, type: "checkbox", ...rest }), _jsx(Tick, {})] }), labelIsString ? _jsx(LabelStyled, { children: label }) : label, hint ? _jsx(HintStyled, { children: hint }) : null] }), isError && (_jsx(InputValidationMessage, { children: errorChildren, status: errorStatus }))] }));
};
//# sourceMappingURL=checkbox.js.map